import { SignedDocumentStatus } from "@wingspanhq/signed-documents/dist/lib/interfaces/signedDocument";
import { StepItem } from "../../../../../../shared/components/Steps";

export const getSignedDocumentProgressSteps = (
  status: SignedDocumentStatus,
  isCounterSign?: boolean
): StepItem[] => {
  const signSteps: Record<SignedDocumentStatus, StepItem[]> = {
    [SignedDocumentStatus.Complete]: [
      {
        title: "Sent",
        status: "Complete"
      },
      {
        title: "Sign",
        status: "Complete"
      },
      {
        title: "Complete",
        status: "Complete"
      }
    ],
    [SignedDocumentStatus.New]: [
      {
        title: "Sent",
        status: "Active"
      },
      {
        title: "Sign",
        status: "Pending"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ],
    [SignedDocumentStatus.Sent]: [
      {
        title: "Sent",
        status: isCounterSign ? "Complete" : "Active"
      },
      {
        title: "Sign",
        status: isCounterSign ? "Active" : "Pending"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ],
    [SignedDocumentStatus.Pending]: [
      {
        title: "Sent",
        status: "Complete"
      },
      {
        title: "Sign",
        status: isCounterSign ? "Active" : "Complete"
      },
      {
        title: "Complete",
        status: "Pending"
      }
    ]
  };

  return signSteps[status];
};
